import {rgba} from "polished"
import {
  success,
  error,
  borderGreyPrimary
} from "@irati/ui/src/global/colors"

import {DealStatus} from "@irati/types"
import {enumToArray} from "@irati/utils/enumToArray"

export const ON = DealStatus.On
export const OFF = DealStatus.Off
export const HIDDEN = DealStatus.Hidden
export const TEST = DealStatus.Test
export const ARCHIVED = DealStatus.Archived
export const UNAVAILABLE = DealStatus.Unavailable

export interface SelectOption {
  value: DealStatus,
  label: DealStatus
}

export const SELECT_OPTIONS: SelectOption[] = enumToArray(DealStatus).map((value) => ({
  value,
  label: value
} as SelectOption)).filter((option) => {
  // Hide unused statuses
  const hiddenStatuses = [DealStatus.Hidden, DealStatus.Test, DealStatus.Removed, DealStatus.UnknownStatus, DealStatus.Unrecognized]
  return !hiddenStatuses.includes(option.value)
})

export const STATUSES = enumToArray(DealStatus)

export const COLOR = {
  [DealStatus.On]: `${rgba(success, 0.2)}`,
  [DealStatus.Off]: `${rgba(error, 0.2)}`,
  [DealStatus.Unavailable]: `${rgba("yellow", 0.2)}`,
  [DealStatus.Hidden]: `${rgba("yellow", 0.2)}`,
  [DealStatus.Test]: `${rgba("orange", 0.3)}`,
  [DealStatus.Archived]: `${rgba(borderGreyPrimary, 0.2)}`
}

export default {ON, OFF, HIDDEN, TEST, UNAVAILABLE, ARCHIVED, SELECT_OPTIONS, STATUSES, COLOR}
